//import { SerializeFrom } from "@remix-run/cloudflare";
import { useFetcher } from "@remix-run/react";
import { useCallback, useEffect, useState } from "react";

interface DataTypeBase<T> {
  data: T[]
  nextCursor: string | null;
  perPage: number;
}

interface LoaderReturnTypeBase<J> {
  cursor: J;
}

interface IdType {
  id: string
}

export function usePaginteData<T extends IdType, DataType extends DataTypeBase<T>, LoaderReturnType extends LoaderReturnTypeBase<DataType>>(
  initialData: DataType,
  loadUrlBase: string
  ///  user/${param.userId}/load
) {
  const fetcher = useFetcher<LoaderReturnType>();

  const [cursor, setData] =
    useState<DataType>(initialData);

  const nextLoad = useCallback(async () => {
    fetcher.load(
      `${loadUrlBase}?nextCursor=${cursor.nextCursor}&perPage=${cursor.perPage}`,
    );
  }, [fetcher, loadUrlBase, cursor.nextCursor, cursor.perPage]);

  useEffect(() => {
    const data = (fetcher.data as LoaderReturnType)?.cursor;
    if (!data) return;
    setData((prev) => {
      return {
        ...data,
        data: [...prev.data, ...data.data],
      };
    });
  }, [fetcher.data]);

  useEffect(() => {
    // 初回のみ
    setData((prev) => {
      return {
        ...initialData,
        data: initialData.data.map((el) => {
          const exists =
            initialData.data?.find(
              (e) => e.id === el.id,
            );
          if (exists) {
            return exists;
          } else {
            return el;
          }
        }),
      };
    });
  }, [initialData]);


  return {
    nextLoad,
    cursor: cursor
  }

}
